module.exports = __webpack_public_path__ + "img/icon-x.ee636d80.svg";